import { GuiButton } from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";

export interface DebugTabData extends PIXI.Container {
    toggle(): void;
    hide():void;
    activated:boolean;
}

export class DebugMenuButton extends GuiButton{

    private btnText:PIXI.Text;
    private bgGraphic:PIXI.Graphics;

    private _pressedCallback:(v:string) => void;
    private _barInfo:DebugTabData;

    private get boxWidht(): number { return 150; }
    private get boxHeight(): number { return 150; }

    constructor(name:string, barInfo:DebugTabData){
        super(name);
        this._barInfo = barInfo;

        this.init();
        this.buttonInteractionState();
    }

    private init():void{
        this.buttonBg();
        this.buttonText();
    }

    protected buttonInteractionState():void{
        this.onPointerStateUpdate = state => {
            switch(state){
                case 2:
                    this.objAlpha = 0.9;
                    break;
                case 1:
                    this.onInteracted();
                    this.objAlpha = 0.6;
                    break;
                default:
                    this.objAlpha = 1;
                    break;
            }
        };
    }

    public onInteracted():void{
        this._barInfo.toggle();
        this._pressedCallback(this.name)
    }

    public setPressedCallback(func: (v: string) => void): void {
        this._pressedCallback = func;
    }

    public get activated(): boolean {
        return this._barInfo.activated;
    }

    public disable(): void {
        this._barInfo.hide();
    }

    public buttonText():void{
        this.btnText = this.addChild(new PIXI.Text(this.name));
        this.btnText.anchor.set(0.5,0.5);
        this.btnText.scale.set(0.9,0.9)
        this.btnText.position.set(0, -this.boxHeight/2 + this.btnText.height / this.btnText.scale.y);
    }

    private set objAlpha(value:number){
        this.btnText.alpha = value;
        this.bgGraphic.alpha = value;
    }

    public buttonBg():void{
        this.bgGraphic = this.addChild(new PIXI.Graphics());

        this.bgGraphic.clear();
        this.bgGraphic.lineStyle(3, 0xffffff, 1);
        this.bgGraphic.beginFill(0xBB4588, 1);

        this.bgGraphic.drawRoundedRect(
            -this.boxWidht/2,
            -this.boxHeight/2,
            this.boxWidht,
            this.boxHeight/2,14);
        this.bgGraphic.endFill();

        this.enable(true)
    }

}